import { UpTransition } from '@components/animations'
import PatientInvoicesQuickPay from '@components/tables/PatientInvoicesQuickPay'
import { Button, DialogContent } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import { useCallback, useEffect, useRef, useState } from 'react'
import {
  IframeShowUIArgs,
  useIframeMessages,
} from '../../../hooks/useIframeMessages'

export const Scheduling = () => {
  const [quickPayOpen, setQuickPayOpen] = useState(false)
  const [selectedPatientId, setSelectedPatientId] = useState<
    number | undefined
  >(undefined)
  const [browserZoom, setBrowserZoom] = useState(1.0)
  const MIN_ZOOM = 0.7
  const MAX_ZOOM = 1.5
  const ZOOM_STEP = 0.1

  useEffect(() => {
    
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.altKey && !e.ctrlKey && !e.metaKey) {
        if (e.key === '+' || e.key === '=') {
          e.preventDefault()
          setBrowserZoom((prev) =>
            Math.min(MAX_ZOOM, +(prev + ZOOM_STEP).toFixed(1)),
          )
        } else if (e.key === '-' || e.key === '_') {
          e.preventDefault()
          setBrowserZoom((prev) =>
            Math.max(MIN_ZOOM, +(prev - ZOOM_STEP).toFixed(1)),
          )
        } else if (e.key === '0') {
          e.preventDefault()
          setBrowserZoom(1.0)
        }
      }
    }

    const handleWheel = (e: WheelEvent) => {
      if (e.altKey && !e.ctrlKey && !e.metaKey) {
        e.preventDefault()
        const delta = e.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP
        setBrowserZoom((prev) =>
          Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, +(prev + delta).toFixed(1))),
        )
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('wheel', handleWheel, { passive: false })

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('wheel', handleWheel)
    }
  }, [])

  const handleShowUIMessage = useCallback((data: IframeShowUIArgs) => {
    const { name } = data
    let patientId: number | undefined
    switch (name) {
      case 'unpaid-bills':
        patientId = data.args.patientId
        if (!patientId) {
          console.error('Missing patientId')
          return
        }
        setSelectedPatientId(patientId)
        setQuickPayOpen(true)
        break
    }
  }, [])
  const { registerIframe } = useIframeMessages({
    'show-ui': handleShowUIMessage,
  })
  return (
    <div
      style={{
        width: '100%',
        height: '98vh',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
      }}
    >
      <iframe
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
          zoom: browserZoom,
          margin: 0,
          padding: 0,
        }}
        src={process.env.REACT_APP_SCHEDULING_URL}
        onLoad={() => registerIframe(window)}
      ></iframe>

      <Dialog
        open={quickPayOpen}
        onClose={() => {
          setQuickPayOpen(false)
          setSelectedPatientId(undefined)
        }}
        TransitionComponent={UpTransition}
        fullScreen
      >
        <DialogContent sx={{ p: 0 }}>
          <div className="flex justify-end p-2">
            <Button variant="outlined" onClick={() => setQuickPayOpen(false)}>
              Fermer
            </Button>
          </div>
          {selectedPatientId != null && (
            <PatientInvoicesQuickPay patientId={selectedPatientId} />
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Scheduling
